export default __webpack_public_path__ + "static/media/calendar.8209a274.svg";